export default __webpack_public_path__ + "8dabd255d61f83d12a5653689a396560.png";